import styled from "styled-components/macro";
import { select } from "../../store/selector";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
      position: relative;
	  background-color: ${(props) => props.theme.colors.background.default};
  }
`;

const BackgroundWrapper = styled.div`
    width: 100%;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    min-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    overflow: hidden;
`;


const FirstCircle = styled.div<{position: number, isHomePage: boolean}>`
    width: ${(props) => props.isHomePage ? "319px": "410px"};
    height: ${(props) => props.isHomePage ? "319px": "410px"};
    position: absolute;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.background.first};
    top: ${(props) => props.isHomePage ? "-62px": "-119px"};
    right: ${(props) => props.isHomePage ? "-69px": "-251px"};
    transition: transform 1500ms ease 200ms;
    will-change: transform;
    transform: ${(props) => 
            props.position === 1 ? "translateX(-240px)" :
            props.position === 2 ? "translateX(140px)" : "translateX(0)"
    };
    
    @media (min-width: 768px) and (max-width: 1200px) {
        top: -154px;
        right: -127px;
    }
    
    @media (min-width: 1200px)  {
		top: -148px;
		right: -127px;
    }
`;

const SecondCircle = styled.div<{isHomePage: boolean}>`
    position: absolute;
    width: 141px;
    height: 141px;
    border-radius: 50%;
	top: ${(props) => props.isHomePage ? "521px": "266px"};
	left: ${(props) => props.isHomePage ? "-53px": "-60px"};
    background-color: ${(props) => props.theme.colors.background.second};
	
	@media (min-width: 768px) and (max-width: 1200px) {
		top: 304px;
		left: 19px;
	}

	@media (min-width: 1200px)  {
		top: 304px;
		left: 49px;
	}
    
`;

const Background = () => {
    const view = useSelector(select.view),
        current = view.currentSlide;
    const { pathname } = useLocation()
    return (
        <BackgroundWrapper>
            <GlobalStyle />
            <FirstCircle position={current} isHomePage={pathname === "/"}/>
            <SecondCircle isHomePage={pathname === "/"}/>
        </BackgroundWrapper>
    );
};

export default Background;
